export default __webpack_public_path__ + "static/media/mallory_compact_ultra_italic.097df2f0.ttf";